import { motion } from "motion/react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  greyMui,
  MOBILE_BREAKPOINT,
  MOBILE_BREAKPOINT_NUMBER,
  redMui,
} from "@ryde/theme";

export const ProfileScopeContainerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "profile-list-container",
})`
  width: 100%;
  align-items: stretch;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${MOBILE_BREAKPOINT_NUMBER + 1}px) {
    display: contents;
  }
`;

export const ProfileCompaniesTitleBlock = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "profile-companies-title-block-left",
})`
  width: 48%;

  h3 {
    margin-top: 3px;
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500;
    color: ${blueGreyMui._500};
  }
  h4 {
    font-size: 14px;
    font-weight: 500;
    color: ${blueGreyMui._900};
    margin-bottom: 4px;
  }
`;

export const ProfileCompaniesSearchBlock = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "profile-companies-search",
})`
  width: 48%;
  padding-inline-end: 10px;
`;

export const ProfileCompanyLoadingStyled = styled.p.attrs<IStyledAttributes>({
  "data-e2e": "profile-company-loading",
})`
  color: ${blueGreyMui._800};
`;

export const ProfileModalHeadStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "profile-modal-head",
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProfileModalCompaniesStyled = styled(
  motion.div,
).attrs<IStyledAttributes>({
  "data-e2e": "profile-modal-companies",
})`
  padding-top: 20px;
  overflow-y: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex: 1;
    min-height: 0;
    padding-bottom: max(76px, calc(48px + env(safe-area-inset-bottom, 0px)));
  }

  @media (min-width: ${MOBILE_BREAKPOINT_NUMBER + 1}px) {
    height: 350px;
  }
`;

export const ProfileModalCompanyItemStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "profile-modal-company-item",
  },
)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  width: calc(100% - 10px);
  &:nth-child(2n + 1) {
    background-color: ${greyMui._200};
  }
  .company_title {
    font-weight: 500;
    color: ${blueGreyMui._700};
    display: flex;
    align-items: center;
    gap: 5px;
    padding-inline-start: 7px;
    padding-inline-end: 7px;
  }
  .role_chose_area {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-inline-start: 7px;
    padding-inline-end: 7px;
    gap: 12px;
    .role_set {
      text-decoration: underline;
      cursor: pointer;
      color: ${blueMui._800};
      &.active_role {
        color: ${redMui._800};
      }
    }
  }
`;
